class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.productsContainer = this.getAttribute('data-products-container');
    this.paginationSelector = this.getAttribute('data-pagination-selector');
    this.nextPageSelector = this.getAttribute('data-next-page-selector');
    
    this.productsContainerEl = document.querySelector(this.productsContainer);
    this.paginationEl = document.querySelector(this.paginationSelector);
    this.loadingIndicator = document.querySelector('.loading-overlay-wrapper');
    
    if (!this.productsContainerEl || !this.paginationEl) return;
    
    this.init();
  }

  init() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      rootMargin: '0px 0px 400px 0px'
    });
    
    this.observer.observe(this.paginationEl.querySelector(this.nextPageSelector));
    this.bindPaginationLinks();
  }

  bindPaginationLinks() {
    this.paginationEl.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', this.handleLinkClick.bind(this));
    });
  }

  handleLinkClick(e) {
    e.preventDefault();
    this.loadPage(e.target.href);
  }

  handleIntersect(entries) {
    if (entries[0].isIntersecting) {
      const nextLink = this.paginationEl.querySelector(this.nextPageSelector);
      if (nextLink) this.loadPage(nextLink.href);
    }
  }

  async loadPage(url) {
    try {
      this.loadingIndicator.classList.remove('hidden');
      
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      
      // Update products
      const newProducts = html.querySelector(this.productsContainer).innerHTML;
      this.productsContainerEl.insertAdjacentHTML('beforeend', newProducts);
      
      // Update pagination
      const newPagination = html.querySelector(this.paginationSelector).innerHTML;
      this.paginationEl.innerHTML = newPagination;
      this.bindPaginationLinks();
      
      // Update URL without refresh
      window.history.pushState({}, '', url);
      
      // Re-init product forms and quick add
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([
          { name: 'product-form', version: '1.0' },
          { name: 'quick-add', version: '1.0' }
        ]);
      }
      
      // Re-attach observer to new next link
      const newNextLink = this.paginationEl.querySelector(this.nextPageSelector);
      if (newNextLink) {
        this.observer.observe(newNextLink);
      }
      
    } catch (error) {
      console.error('Infinite scroll error:', error);
    } finally {
      this.loadingIndicator.classList.add('hidden');
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);